import React from 'react';
import JsiLogo from '@components/JsiLogo/JsiLogo';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');

const cloudPanel = props => {
  let styles = {};
  if (window.innerWidth < 992) {
    styles.minHeight = props.screenHeight + 'px';
    styles.backgroundImage = `url(${Clouds})`;
    styles.backgroundSize = 'auto 100%';
    styles.backgroundPosition = 'center center';
    styles.position = 'relative';
    styles.maxWidth = '100%';
    styles.overflowX = 'hidden';
  } else {
    styles.height = props.screenHeight + 'px';
  }

  return (
    <div
      id={props.id}
      className={'panel d-flex align-items-center'}
      style={styles}
    >
      <img
        src={Clouds}
        alt={'Slider1'}
        className={'img-fluid d-none d-lg-block'}
      />
      {(props.hideJSILogo === undefined || props.hideJSILogo === false) && (
        <JsiLogo />
      )}
      {props.children}
    </div>
  );
};

export default cloudPanel;



// WEBPACK FOOTER //
// ./src/components/CloudPanel/CloudPanel.jsx